import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { PreviewImageDirective } from './preview-image.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, PortalModule],
  exports: [PreviewImageDirective],
  declarations: [PreviewImageDirective],
})
export class PreviewImageModule {}
